// Non-translatable configuration (text lives in i18n.jsx)

export const company = {
  name: "Tele-Comp Solutions",
  phone: "(305) 718-8718",
};

export const contactInfo = {
  phone: "(305) 718-8718",
  email: "sales@tele-comp.com",
};

// WhatsApp click-to-chat config (no API key needed for wa.me links)
export const whatsapp = {
  number: "13057188718", // international format, digits only
  display: "(305) 718-8718",
};

export const navConfig = [
  { key: "home", href: "/#home" },
  { key: "about", href: "/#about" },
  { key: "catalog", href: "/catalog" },
  { key: "services", href: "/#services" },
  { key: "contact", href: "/#contact" },
  { key: "subscribe", href: "/#newsletter" },
];

export const heroImages = {
  hero: "/uploads/PHOTO-2026-05-26-11-28-26.jpg",
  about: "/uploads/PHOTO-2026-05-16-10-58-37.jpg",
};

// Hero collage / mosaic (mix of inventory shots)
export const heroCollage = [
  "/uploads/PHOTO-2026-05-26-11-28-26.jpg", // container aisle (tall)
  "/uploads/PHOTO-2026-05-21-09-56-47.jpg", // tower rows
  "/uploads/PHOTO-2026-03-25-18-46-31.jpg", // boxed CPUs
];

export const aboutVideo = "/uploads/VIDEO-2026-05-16-12-12-50.mp4";

// Product categories: id + image (names come from i18n)
export const categoryConfig = [
  { id: "monitors", image: "/uploads/PHOTO-2026-05-16-11-00-52.jpg" },
  { id: "desktops", image: "/uploads/PHOTO-2026-05-28-14-53-55.jpg" },
  { id: "laptops", image: "/uploads/PHOTO-2026-05-16-11-00-24.jpg" },
  { id: "notebooks", image: "/uploads/PHOTO-2026-05-20-15-14-03.jpg" },
  { id: "sff", image: "/uploads/PHOTO-2026-05-26-09-47-44.jpg" },
  { id: "towers", image: "/uploads/PHOTO-2026-05-26-11-21-11.jpg" },
  { id: "micros", image: "/uploads/PHOTO-2026-05-28-14-54-02.jpg" },
];

// Parts & accessories: id + icon + (technical, non-translated) tags
export const partsConfig = [
  { id: "memory", icon: "MemoryStick", tags: ["DDR3", "DDR4", "8GB", "16GB", "32GB"] },
  { id: "storage", icon: "HardDrive", tags: ["SSD", "Mechanical", "M.2", "SATA", "NVMe"] },
  { id: "keyboards", icon: "Keyboard", tags: [] },
  { id: "mice", icon: "Mouse", tags: [] },
  { id: "power-cables", icon: "Cable", tags: [] },
  { id: "ac-adapters", icon: "Plug", tags: [] },
];

// Services: id + icon (text from i18n)
export const servicesConfig = [
  { id: "refurbishing", icon: "Recycle" },
  { id: "data-wiping", icon: "ShieldCheck" },
  { id: "wholesale", icon: "Boxes" },
  { id: "configuration", icon: "Settings2" },
  { id: "disposition", icon: "Leaf" },
  { id: "shipping", icon: "Globe" },
];

// Trust features strip: id + icon (text from i18n)
export const featuresConfig = [
  { id: "shipping", icon: "Truck" },
  { id: "payments", icon: "CreditCard" },
  { id: "support", icon: "Headphones" },
];
